"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyAccount = exports.MY_ACCOUNT_PATH = void 0;
require("../../../scss/myAccount.scss");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../constants");
const addressTypes_1 = require("../../../models/addressTypes");
const ContactInformation_1 = require("./ContactInformation");
const Newsletter_1 = require("./Newsletter");
const Address_1 = require("./Address");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
exports.MY_ACCOUNT_PATH = "/my-account";
const MyAccount = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const actions = customerAccountContext.actions;
    const [addressBook] = actions.addresses.addressesHook();
    return (react_1.default.createElement("div", { className: "boutik-customer-account-myaccount" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-myaccount-title" }, t("customerAccount.myAccount.sectionTitle")),
        react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-account-information" },
            react_1.default.createElement("h1", { className: "boutik-customer-account-myaccount-account-information-title" }, t("customerAccount.myAccount.accountInformation")),
            react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-account-information-container" },
                react_1.default.createElement(ContactInformation_1.ContactInformation, null),
                react_1.default.createElement(Newsletter_1.Newsletter, null))),
        react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-address" },
            react_1.default.createElement("h1", { className: "boutik-customer-account-myaccount-address-title" }, t("customerAccount.myAccount.defaultAddresses")),
            react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-address-container" },
                react_1.default.createElement(Address_1.Address, { address: addressBook.defaultBillingAddress, type: addressTypes_1.AddressTypes.BILLING }),
                react_1.default.createElement(Address_1.Address, { address: addressBook.defaultShippingAddress, type: addressTypes_1.AddressTypes.SHIPPING })))));
};
exports.MyAccount = MyAccount;
//# sourceMappingURL=MyAccount.js.map